import React from "react";
import { useListQuotationsQuery } from "../../sales/quotations/quotationsApi";

const money = (n) => Number(n || 0).toFixed(2);

// Optional "link this document to one of the customer's already-approved
// Quotations" picker - Phase 2 of the Quotation module, shared by LPO and
// Stock-Out. Only queries once a customer is actually selected; the list
// is always scoped to APPROVED + that exact customer (custId+branchId),
// same additive filter Batch114 added for the Sales Enquiry/Order picker.
const ApprovedQuotationPicker = ({ custId, customerBranchId, value, onChange, disabled }) => {
  const canQuery = Boolean(custId && customerBranchId);

  const { data, isFetching } = useListQuotationsQuery(
    { status: "APPROVED", custId, branchId: customerBranchId, pageSize: 100 },
    { skip: !canQuery }
  );
  const quotations = data?.items || [];

  return (
    <select
      className="form-control"
      value={value || ""}
      disabled={disabled || !canQuery || isFetching}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <option value="">{canQuery ? "None (optional)" : "Select a customer first"}</option>
      {quotations.map((q) => (
        <option key={q.recordGuid} value={q.recordGuid}>{q.quotationNumber} - {money(q.totalAmount)}</option>
      ))}
    </select>
  );
};

export default ApprovedQuotationPicker;
